/**
 * Start step 2 (Profile & Categories).
 *
 * There is no bio at signup (Nicky, 27 Oct 2026): the step has no bio field and
 * its save never writes `bio`, so a bio the page already has (for example one
 * the builder prefilled from the creator's Instagram) is left untouched. The bio
 * is edited only in the dashboard ("Bio for ShoutOut Profile").
 */
export interface StartProfileFields {
  fullName: string;
  username: string;
  categories: string[];
  targetingCategory: string;
  pricing: number;
  fulfillmentTime: number;
  avatarUrl: string;
}

/** The message to show when step 2 can't save yet, or null when it can. */
export function startProfileFieldsError(fields: Pick<StartProfileFields, 'categories' | 'targetingCategory'>): string | null {
  if (fields.categories.length === 0) return 'Select at least one category';
  if (!fields.targetingCategory) return 'Select your content type';
  return null;
}

/** The talent_profiles update step 2 saves. Never includes `bio`. */
export function startProfileUpdate(fields: StartProfileFields, selectedShoutoutTypes: string[]) {
  return {
    full_name: fields.fullName,
    temp_full_name: fields.fullName,
    username: fields.username.toLowerCase(),
    pricing: fields.pricing,
    fulfillment_time_hours: fields.fulfillmentTime,
    temp_avatar_url: fields.avatarUrl,
    category: fields.categories[0],
    categories: fields.categories,
    targeting_category: fields.targetingCategory,
    selected_shoutout_types: selectedShoutoutTypes,
  };
}
